import { render, staticRenderFns } from "./DcExtendedMatch.vue?vue&type=template&id=e2723dae&scoped=true&"
import script from "./DcExtendedMatch.vue?vue&type=script&lang=js&"
export * from "./DcExtendedMatch.vue?vue&type=script&lang=js&"
import style0 from "./DcExtendedMatch.vue?vue&type=style&index=0&id=e2723dae&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2723dae",
  null
  
)

export default component.exports